var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"tw-scroll-x"},[_c('v-uni-scroll-view',{staticClass:"a-w-100_ a-overflow-hidden scroll-list-x",attrs:{"scroll-x":"true"}},[_vm._t("default")],2)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }